import { useEffect } from 'react';
import { useInitialize, useVisitorCode } from '@kameleoon/react-sdk';
import { getExternalKameleoonVisitorCode, syncKameleoonVisitorCodeFromQuery } from './visitorCode';

const KameleoonInitializer = ({ children }) => {
  const { initialize } = useInitialize();
  const { getVisitorCode } = useVisitorCode();

  useEffect(() => {
    const init = async () => {
      try {
        syncKameleoonVisitorCodeFromQuery();
        await initialize();
        const visitorCode = getExternalKameleoonVisitorCode() || getVisitorCode();
        console.log('[Kameleoon] Initialized. Visitor:', visitorCode);
      } catch (error) {
        console.error('[Kameleoon] Failed to initialize:', error.message);
      }
    };

    init();
  }, [initialize, getVisitorCode]);

  return children;
};

export default KameleoonInitializer;

